import { STATUS_PALETTE } from '@/shared/constants/statusPalette'
import { cn } from '@/shared/lib/utils'

/**
 * Legacy setPanelColor parity for Instrument Tasks row shading:
 * failed QC or ODE → danger, RDY → ready, DNW → due-now, else none (UTD).
 */
export type TaskStatusRowTint = 'danger' | 'ready' | 'due-now'

export function taskStatusRowTint(
  taskStatusCode: string | null | undefined,
  latestQcPassed: boolean | null | undefined,
): TaskStatusRowTint | null {
  if (latestQcPassed === false || taskStatusCode === 'ODE') return 'danger'
  if (taskStatusCode === 'RDY') return 'ready'
  if (taskStatusCode === 'DNW') return 'due-now'
  return null
}

export function taskStatusRowTintClassName(tint: TaskStatusRowTint | null): string {
  switch (tint) {
    case 'danger':
      return cn(STATUS_PALETTE.red.tintBg, STATUS_PALETTE.red.border)
    case 'ready':
      return cn(STATUS_PALETTE.blue.tintBg, STATUS_PALETTE.blue.border)
    case 'due-now':
      return cn(STATUS_PALETTE.green.tintBg, STATUS_PALETTE.green.border)
    default:
      return ''
  }
}
